// Dashboard tokens — mostly re-exports from AppLayout so colors stay consistent
export { APP_COLORS, APP_FONT } from '../../components/AppLayout/tokens';

// Dashboard-specific sizes
export const DASH_SIZES = {
  servicePillHeight: 44,
  servicePillCircle: 32,
  servicePillGap: 14,
  cardRadius: 14,
  chartHeight: 180,
  heroAvatarSize: 52,
} as const;

// Service pill brand circle color (same for every service, per approved design)
export const SVC_CIRCLE_COLOR = '#0F3E4F';

// Donut category colors (for ExpensesDonutCard)
export const CATEGORY_PALETTE: ReadonlyArray<string> = [
  '#15A08C', // teal
  '#6B46C1', // vela purple
  '#F59E0B', // amber
  '#2563EB', // blue
  '#B53B2E', // red
  '#0F6E56', // teal-ink
];
